(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Yasqe", [], factory);
	else if(typeof exports === 'object')
		exports["Yasqe"] = factory();
	else
		root["Yasqe"] = factory();
})(window, function() {
return 